import src from "IMAGE";
export default { src, width: 795, height: 795, blurWidth: 0, blurHeight: 0};
